module.exports = __webpack_public_path__ + "img/map.c979cadd.png";